@if (factSheet) {
  <div class="m-8">
    <h2>{{ getSingleString('//project-factsheet/title') }}</h2>
    <div class="flex flex-col items-baseline">
      <gx-description-list [isInline]="false" [items]="generalItems"></gx-description-list>
      <gx-button text="Confluence" variant="prime" class="w-1/3" (click)="openConfluence()"></gx-button>
    </div>
  </div>
}
